import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { saleAPI } from '../../services/api';
import toast from 'react-hot-toast';
import SaleForm from './SaleForm';
import SaleList from './SaleList';

const MySales = () => {
  const { user } = useAuth();
  const [sales, setSales] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingSale, setEditingSale] = useState(null);
  const [filters, setFilters] = useState({
    dateFrom: '',
    dateTo: '',
    vendorId: '',
    productId: ''
  });

  useEffect(() => {
    fetchSales();
  }, [filters]);

  const fetchSales = async () => {
    try {
      setLoading(true);
      const params = {};
      if (filters.dateFrom) params.dateFrom = filters.dateFrom;
      if (filters.dateTo) params.dateTo = filters.dateTo;
      if (filters.vendorId) params.vendorId = filters.vendorId;
      if (filters.productId) params.productId = filters.productId;
      
      const response = await saleAPI.getAll(params);
      setSales(response.data.data || []);
    } catch (error) {
      console.error('Error fetching sales:', error);
      toast.error('Failed to load sales');
    } finally {
      setLoading(false);
    }
  };

  const handleAddSale = () => {
    setEditingSale(null);
    setShowModal(true);
  };

  const handleEditSale = (sale) => {
    setEditingSale(sale);
    setShowModal(true);
  };

  const handleDeleteSale = async (id) => {
    if (!window.confirm('Are you sure you want to delete this sale?')) return;
    
    try {
      await saleAPI.delete(id);
      toast.success('Sale deleted successfully');
      fetchSales();
    } catch (error) {
      console.error('Error deleting sale:', error);
      toast.error('Failed to delete sale');
    }
  };

  const handleSaveSale = async (saleData) => {
    try {
      if (editingSale) {
        await saleAPI.update(editingSale.id, saleData);
        toast.success('Sale updated successfully');
      } else {
        await saleAPI.create(saleData);
        toast.success('Sale added successfully');
      }
      setShowModal(false);
      fetchSales();
    } catch (error) {
      console.error('Error saving sale:', error);
      toast.error(error.response?.data?.message || 'Failed to save sale');
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 py-6">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">My Sales</h1>
          <p className="text-gray-600 mt-1">
            {user?.role === 'admin' ? 'All team sales' : 'Orders you\'ve recorded with vendors'}
          </p>
        </div>
        <button
          onClick={handleAddSale}
          className="bg-teal-600 text-white px-4 py-2 rounded-lg hover:bg-teal-700 transition-colors flex items-center gap-2"
        >
          <i className="ti ti-plus" />
          Record Sale
        </button>
      </div>

      <SaleList
        sales={sales}
        loading={loading}
        onEdit={handleEditSale}
        onDelete={handleDeleteSale}
        filters={filters}
        setFilters={setFilters}
        isAdmin={user?.role === 'admin'}
      />

      <SaleForm
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onSave={handleSaveSale}
        sale={editingSale}
      />
    </div>
  );
};

export default MySales;